export default "__VITE_ASSET__2df981f7__"